export enum UrlParams {
  orderby = '$orderby',
  top = '$top',
  skip = '$skip',
  count = '$count',

  nameContains = '$filter',
  filterClause = '$filter',
}
